import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { registerUser } from "../api";
import "./Auth.css";

const Signup = () => {
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await registerUser(form);
      alert(res.message || "Signup Successful!");
      navigate("/verify-email");
    } catch (error) {
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <h2 className="auth-heading">Signup</h2>  {/* 👈 class add ki */}

      <form className="auth-form" onSubmit={handleSubmit}>  {/* 👈 class add ki */}
        <input name="name" placeholder="Name" onChange={handleChange} required />
        <input name="email" placeholder="Email" onChange={handleChange} required />
        <input name="phone" placeholder="Phone" onChange={handleChange} required />
        <input name="password" type="password" placeholder="Password" onChange={handleChange} required />

        <button type="submit" disabled={loading}>
          {loading ? "Signing..." : "Signup"}
        </button>
      </form>

      <p className="auth-link">  {/* 👈 class add ki */}
        Already have account? <Link to="/login">Login</Link>
      </p>
    </div>
  );
};

export default Signup;